import {IOrderRequest} from "@/store/types/Order";
import {apiService} from "@/services/ApiService";
import {OrderDetailResponse} from "@/services/types/OrderDetailResponse";

export class OrderDetailService {

    public async GetByOrderNumberAndPostalCode(
        payload: IOrderRequest
    ) {
        const response = await apiService.get<OrderDetailResponse>(
            `SelfScheduling/Order/OrderNumber/${payload.externalOrderNumber}/PostalCode/${payload.postcode}`,
            {});

        return {
          isOk: response.data.isOk,
          order: response.data.order
        }
    }

    public async GetByOrderNumberAndHash(
        payload: IOrderRequest
    ) {
        const response = await apiService.get<OrderDetailResponse>(
            `SelfScheduling/Order/OrderNumber/${payload.externalOrderNumber}/Hash/${payload.hash}`,
            {}
        );

        return {
        isOk: response.data.isOk,
        order: response.data.order
      }
    }
}

export const orderDetailService = new OrderDetailService();
